"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorDialogComponent = void 0;
var error_dialog_component_1 = require("./error-dialog-component");
Object.defineProperty(exports, "ErrorDialogComponent", { enumerable: true, get: function () { return error_dialog_component_1.ErrorDialogComponent; } });
//# sourceMappingURL=index.js.map